import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-document-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss']
})
export class DocumentPreviewComponent {
  @Input() isVisible: boolean = false;
  @Input() file: File | null = null;
  @Output() close = new EventEmitter<void>();

  previewUrl: SafeUrl | null = null;
  fileType: 'image' | 'pdf' | 'other' = 'other';
  fileName: string = '';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges() {
    if (this.file) {
      this.fileName = this.file.name;
      
      if (this.file.type.startsWith('image/')) {
        this.fileType = 'image';
        this.createImagePreview();
      } else if (this.file.type === 'application/pdf') {
        this.fileType = 'pdf';
        this.createPdfPreview();
      } else {
        this.fileType = 'other';
      }
    }
  }

  private createImagePreview() {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.previewUrl = this.sanitizer.bypassSecurityTrustUrl(e.target.result);
    };
    reader.readAsDataURL(this.file!);
  }

  private createPdfPreview() {
    const fileUrl = URL.createObjectURL(this.file!);
    this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);
  }

  closePreview() {
    this.close.emit();
    if (this.fileType === 'pdf' && this.previewUrl) {
      URL.revokeObjectURL(this.previewUrl as string);
    }
    this.previewUrl = null;
  }
}